<template>
  <div class="bg_index">
    <!--banner-->
    <productBanner :Product="product" class="bannerFather"></productBanner>

    <!-- <TechnicalHighlights :list="techDes"></TechnicalHighlights> -->

    <div class="w100 hxjs" style="height: 1320px;">
      <div class="light">产品亮点</div>
      <div class="other1">
        <div v-for="(item,index) in cardMsg1" :key="index">
          <coreCard :cardMsg="item"></coreCard>
        </div>
      </div>
    </div>

    <!-- 使用场景 -->
    <suitCase :list="suit" class="suitcase"></suitCase>

    <div style="background-color: white;">
      <productDownload :product="download"></productDownload>
    </div>

    <div class="submit" id="submit">
      <cooperateForm class="submitform"></cooperateForm>
      <div class="footblack" />
    </div>
  </div>
</template>

<script>
import cooperateForm from '@/components/common/cooperateForm'
import suitCase from '@/components/common/suitCase'
import productBanner from '@/components/common/productBanner'
import TechnicalHighlights from '@/components/common/TechnicalHighlights'
import coreCard from '@/components/common/coreCard'
import productDownload from '@/components/common/productDownload'
import { BaseURL } from '@/api/http.js'

export default {
  data () {
    return {
      download: '彩页图',
      suit: [
        { 'img': 'images/chanpin/sm_bot1.png', 'context': ['银行、保险、证券及互联网金融、社保及政企部门呼叫', '中心（客服热线电话）的客户身份验证'] },
        { 'img': 'images/chanpin/sm_bot2.png', 'context': ['智能家居、智能锁、互联网汽车、社交网络等移动互联网、', '物联网应用的身份与权限识别'] }
      ],
      techDes: [
        { 'title': '安全可靠', 'context': '超过70种语音特征验证<br />多重认证模式<br />防录音合成欺诈', 'img': 'images/sm/sm_js_1.png' },
        { 'title': '高适应性', 'context': '支持近场和多种语音信道<br />支持低信噪比语音信道', 'img': 'images/sm/sm_js_2.png' },
        { 'title': '响应迅速', 'context': '秒级响应', 'img': 'images/sm/sm_js_3.png' },
        { 'title': '简单易用', 'context': '无需特殊技能<br />老幼适用', 'img': 'images/sm/sm_js_4.png' },
        { 'title': '灵活扩展', 'context': '可结合人脸识别<br />以及与第三方应用集成', 'img': 'images/sm/sm_js_5.png' }
      ],
      // cardMsg1: [{
      //   'img': 'images/sm/sm_js_10.png',
      //   'h3': '可靠',
      //   'p': [],
      //   'li': [
      //     ['超过70个声纹特征点验证，轻微感冒或情绪状态波动、口', '罩遮挡不受影响；'],
      //     ['可按场景、时间段添加语音样本，系统自学习更新声纹模', '型，自适应场景变化；']]
      // }, {
      //   'img': 'images/sm/sm_js_11.png',
      //   'h3': '安全',
      //   'p': [],
      //   'li': [
      //     ['内置的反录音欺诈组件，可阻止任何通过录音和录音拼接', '进行语音验证；'],
      //     ['声纹、密码内容、自由说话多重认证，密码自动随机生成；'],
      //     ['用户可自定义密码短语；'],
      //     ['可与人脸识别结合，双模态认证，从此不用摆摆头、眨眨眼；']]
      // }, {
      //   'img': 'images/sm/sm_js_13.png',
      //   'h3': '便捷',
      //   'p': [],
      //   'li': [
      //     ['整个验证过程仅需几秒钟；'],
      //     ['多信道：支持麦克风、VoIP、3G/4G/5G移动通信、固话', '等语音信道；'],
      //     ['语言、方言无关；'],
      //     ['多场景交付模式：本地一站式部署、SaaS云服务、集成到', 'IVR、CRM、移动APP等应用中；']]
      // }, {
      //   'img': 'images/sm/sm_js_14.png',
      //   'h3': '易用',
      //   'p': [],
      //   'li': [
      //     ['不需要任何先验技能或知识，不需要记密码，老幼适用；']]
      // }],
      cardMsg1: [{
        'img': 'images/sm/sm_js_10.png',
        'h3': '可靠',
        'p': [],
        'li': [
          '超过70个声纹特征点验证，轻微感冒或情绪状态波动、口罩遮挡不受影响；',
          '可按场景、时间段添加语音样本，系统自学习更新声纹模型，自适应场景变化；']
      }, {
        'img': 'images/sm/sm_js_11.png',
        'h3': '安全',
        'p': [],
        'li': [
          '内置的反录音欺诈组件，可阻止任何通过录音和录音拼接进行语音验证；',
          '声纹、密码内容、自由说话多重认证，密码自动随机生成；',
          '用户可自定义密码短语；',
          '可与人脸识别结合，双模态认证，从此不用摆摆头、眨眨眼；']
      }, {
        'img': 'images/sm/sm_js_13.png',
        'h3': '便捷',
        'p': [],
        'li': [
          '整个验证过程仅需几秒钟；',
          '多信道：支持麦克风、VoIP、3G/4G/5G移动通信、固话等语音信道；',
          '语言、方言无关；',
          '多场景交付模式：本地一站式部署、SaaS云服务、集成到IVR、CRM、移动APP等应用中；']
      }, {
        'img': 'images/sm/sm_js_14.png',
        'h3': '易用',
        'p': [],
        'li': [
          '不需要任何先验技能或知识，不需要记密码，老幼适用；']
      }],
      product: {
        'background': 'images/chanpin/sm_banner.png',
        'img': 'images/chanpin/sm_ct.png',
        'h2': ['基于声纹的远程身份验证', '解决方案'],
        'desc': [],
        // 'h3': [],
        'p': ['系列—语音卫士'],
        'product': 'images/chanpin/sm.png'
      }
    }
  },
  methods: {
    // 以打开新页面的方式下载文件
    downloadWord () {
      // console.log('下载')
      const name = '彩页图'
      const url = BaseURL + 'materials/downloadByName?typeName=' + name
      window.open(url)
    }
  },
  components: {
    cooperateForm: cooperateForm,
    TechnicalHighlights,
    suitCase,
    productBanner,
    coreCard,
    productDownload
  }
}
</script>

<style scoped>
.submitform {
  width: 803px;
  margin-top: 75px;
  margin-bottom: -23px;
}
.suitcase {
  background-color: rgba(248, 248, 248, 1);
}
.suitcase /deep/ .cjapply {
  width: 526px;
}
.suitcase /deep/ .cjapply {
  width: 526px;
}
.suitcase /deep/ #cj {
  width: 1106px;
}
.submit {
  margin-bottom: -24px;
}
.xccy {
  width: 100%;
  height: 240px;
  margin-bottom: 30px;
  background-color: white;
}

.xccy img {
  margin-top: 57px;
  height: 150px;
}
.footblack {
  height: 50px;
  width: 100%;
  background: rgba(248, 248, 248, 1);
}
/* banner */
.bannerFather /deep/ .product-h2 {
  /* position: absolute; */
  /* position: absolute; */
  text-align: left;
  left: 0px;
  top: 0px;
  font-size: 50px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  margin-top: -3px !important;
  margin-bottom: 45px;
  width: 130%;
}
.bannerFather /deep/ .product {
  /* background: rgba(248,248,248,1); */
  padding-top: 0px;
}
.bannerFather /deep/ .brand {
  width: 52px;
  height: 25px;
  margin-left: 0px;
  margin-top: -25px;
}
.bannerFather /deep/ .banner {
  margin-top: -2px !important;
}
.bannerFather /deep/ .reg {
  font-size: 25px;
  margin-left: 57px;
  margin-top: -35px;
}
.bannerFather /deep/ .desc {
  margin-top: 15px;
}
.bannerFather /deep/ .product-p {
  font-size: 22px;
}
.bannerFather /deep/ .product-p :first-child {
  margin-left: 78px;
  margin-top: -7px;
}
.bannerFather /deep/ .caiye {
  margin-top: 57px;
}
/* 产品亮点 */
.light {
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 96px;
}
.other1 {
  margin: 0 auto;
  width: 1000px;
  height: 980px;
}
.other1 > div {
  float: left;
  margin-left: 46px;
  margin-top: 35px;
}
.other1 /deep/ .context .item-core {
  margin-top: 10px;
}
.other1 /deep/ .context > :first-child {
  margin-top: 28px;
}
.other1 /deep/ .context .item-core :nth-child(2) {
  width: 365px;
}
.other1 /deep/ .app {
  min-height: 500px;
  width: 430px;
}
.other1 /deep/ .title {
  height: 260px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/SoundSafe.vue